export const buildReturnToWebsiteUrl = (country: string): string => {
  const otherCountryDomains = ['AU', 'BR', 'CO', 'DZ', 'MX', 'HK', 'TR'];

  if (otherCountryDomains?.includes(country)) {
    return `https://decathlon.com.${country?.toLowerCase()}`;
  }

  return `https://decathlon.${country?.toLowerCase()}`;
};
